import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { SIGNATURES } from "../lib/menuData";

const Card = ({ item, i }) => (
  <motion.article
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
    className="group relative overflow-hidden rounded-sm border border-gold/15 bg-teal-deep"
    data-testid={`signature-card-${i}`}
  >
    <div className="relative h-72 overflow-hidden">
      <img src={item.img} alt={item.name}
        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
      <div className="absolute inset-0 bg-gradient-to-t from-teal-dark via-teal-dark/20 to-transparent" />
      <span className="absolute top-4 left-4 overline text-[0.6rem] bg-teal-dark/70 backdrop-blur px-3 py-1 rounded-full border border-gold/25">
        {item.tag}
      </span>
    </div>
    <div className="p-6">
      <h3 className="font-serif text-2xl text-cream group-hover:text-gold transition-colors">{item.name}</h3>
      <p className="mt-2 text-cream/65 text-sm leading-relaxed">{item.desc}</p>
    </div>
  </motion.article>
);

export const Signature = () => (
  <section id="spezialitaeten" className="relative bg-teal-dark py-24 md:py-36 grain">
    <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-10">
      <div className="flex items-end justify-between flex-wrap gap-6 mb-16">
        <div>
          <Overline className="mb-5">Die Favoriten</Overline>
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-cream leading-tight">
              Unsere <span className="italic text-gold">Spezialitäten</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <p className="max-w-sm text-cream/65 text-base leading-relaxed">
            Eine Auswahl der Gerichte, für die man wiederkommt – von aromatischen
            Currys bis zum herzhaften Kottu Roti.
          </p>
        </Reveal>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {SIGNATURES.map((item, i) => <Card key={item.name} item={item} i={i} />)}
      </div>
    </div>
  </section>
);
